export default __webpack_public_path__ + "static/media/privilege-wheel-yellow.a0da5e17.svg";